"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("./Icons"));
var _FullBar = _interopRequireDefault(require("./FullBar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Modal = function Modal(props) {
  //render
  var modalClasses = (0, _classnames["default"])("modal-component", props.className, props.type, {
    "withSideMenu": props.sideMenu
  });
  var hasTopBar = props.topBarLeft || props.topBarMiddle || props.topBarRight;

  // Side Menu
  var sideMenu = props.sideMenu ? props.sideMenu.map(function (menuItem, index) {
    var itemClass = (0, _classnames["default"])("menuItem", menuItem.className, {
      "selected": menuItem.selected
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "menu-item-".concat(index),
      "data-value": menuItem.value,
      className: itemClass,
      onClick: menuItem.onClick
    }, /*#__PURE__*/_react["default"].createElement("p", null, menuItem.text), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rightContent"
    }, menuItem.iconContent != null ? /*#__PURE__*/_react["default"].createElement("p", {
      className: "mice"
    }, menuItem.iconContent) : /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "glyph-edit-alt",
      type: "glyph"
    })));
  }) : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses,
    id: props.id
  }, hasTopBar && /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
    left: props.topBarLeft,
    middle: props.topBarMiddle,
    right: props.topBarRight
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modalContentContainer"
  }, sideMenu && /*#__PURE__*/_react["default"].createElement("div", {
    className: "sideMenuContainer"
  }, sideMenu), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modalContent"
  }, props.content, props.children)), props.backButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixedBackButton",
    onClick: props.backButton
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    className: "fixedBackButton",
    name: "glyph-arrow-head",
    type: 'framed-glyph-ext-1'
  })));
};
Modal.propTypes = {
  id: _propTypes["default"].string,
  topBarLeft: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  topBarMiddle: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  topBarRight: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  type: _propTypes["default"].oneOf(["", "ext-1"]),
  sideMenu: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    iconContent: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].number]),
    selected: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    className: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })),
  backButton: _propTypes["default"].func,
  content: _propTypes["default"].any,
  className: _propTypes["default"].string
};
Modal.defaultProps = {
  backButton: null,
  id: "",
  type: ""
};
var _default = exports["default"] = Modal;